import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { eUserPermissionLevel } from '@hub/generated/enums';
import { CurrentUserService } from 'app/services';
import { ConfirmationService } from 'primeng/api';
import { Observable, Observer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserSystemModuleGuard implements CanActivate {
	constructor(
		private currentUserService: CurrentUserService,
		private confirmationService: ConfirmationService
	) {	}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
		const systemModules = route.data["systemModule"] as Array<number>;

		return new Observable((observer: Observer<boolean>) => {
			const userSystemModules = this.currentUserService.UserSystemModules.getValue();

			let canActivate =  userSystemModules
				.some(x => x.SystemModuleId === systemModules[0]
					&& x.UserPermissionLevelFlag >= eUserPermissionLevel.Read
				);

			if (canActivate) {
				observer.next(true);
				observer.complete();
			} else {
				this.rejectPermission(observer);
			}
		});
	}

	public rejectPermission(observer: Observer<boolean>) {
		this.confirmationService.confirm({
			key: 'no-permission',
			message: 'No permission to access',
			reject: () => {
				observer.next(false);
				observer.complete();
			}
		});
	}
}
